<template>
  <div class="maindiv index-wrap bg-gray index_main">
    <custome/>
    <banner ref="banner" :banners="infos.banner"></banner>
    <div class="newsdiv htmldiv mt20" style="display: flex">
<!--      wd370-->

      <news  v-if="infos.schoolNews" :items="infos.schoolNews" />

<!--      <div class="notices wd500 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop" >-->
<!--        <div class="st bborder pb5">-->
<!--          <router-link to="/evn/list?id=0&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>-->
<!--          <div class="dinline-block">-->
<!--            <div class="sst fs24 mr5 dinline-block prelative">-->
<!--              <span class="img-notice img-bg dinline-block vcenter"></span>-->
<!--              校内新闻-->
<!--            </div>-->
<!--            <span class="farial tc9 tupper">Notice</span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="cont pt20" >-->
<!--          <template v-if="infos.notice">-->
<!--            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.schoolNews" v-if="index<8"-->
<!--                 @click="$router.push(`/evn/detail?id=0&pid=2&article_id=${info.id}&num=${index}`)">-->
<!--                {{info.title}}-->
<!--            </div>-->
<!--          </template>-->
<!--        </div>-->
<!--      </div>-->


<!--      <news v-if="infos.schoolNews" :items="infos.schoolNews" />-->
      <div class="notices wd400 ht400 bgw pl15 pr20 pt20 dinline-block br5 vtop ml10" style="width: 375px">
        <div class="st bborder pb5">
          <router-link to="/evn/list?id=0&pid=2" class="more fr tc6 br30 mt5 trans3">更多 +</router-link>
          <div class="dinline-block">
            <div class="sst fs24 mr5 dinline-block prelative">
              <span class="img-news img-bg dinline-block vcenter"></span>
              通知公告
            </div>
            <span class="farial tc9 tupper">News</span>
          </div>
        </div>
        <div class="cont pt20">
          <template v-if="infos.schoolNews">
            <div class="sdiv pl5 cpointer fs16 lh16 ofhidden prelative mb5 pl20 pr5" v-for="(info,index) in infos.notice" v-if="index<8"
                 @click="$router.push(`/evn/detail?id=1&pid=2&article_id=${info.id}&num=${index}`)">
              {{info.title}}
            </div>
          </template>
        </div>
      </div>

      <div class="sns wd370 ht400 bgw pl15 pr10 pt20 dinline-block br5 vtop" style="margin-left: 10px">
          <div class="st bborder pb5">
            <div class="tab sst dinline-block prelative fs0 cpointer mr20" data-key="1">
              <span class="img-zh img-bg dinline-block vcenter"></span>
              <span class="fs24 vcenter">智慧校园</span>
            </div>
          </div>
          <div class="cont pt20">
            <div class="scont scont1 pt20">
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">身份认证</div>
              </a>
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">OA办公系统</div>
              </a>
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">后勤服务</div>
              </a>
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">网络服务</div>
              </a>
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">图书馆</div>
              </a>
              <a href="#" class="sdiv sdiv1 dinline-block vtop br5 pt20 mb25 mr10">
                <div class="igs mat"></div>
                <div class="fs15 tcenter mt10">教务系统</div>
              </a>
            </div>
          </div>

      </div>
    </div>






    <div class="friend htmldiv bgw pl15 pr20 pt20 pb10 br5 mt20">
      <div class="st bborder pb5">
        <!--router-link to="/evn/list?id=7&pid=1" class="more fr tc6 br30 mt5 trans3">更多 +</router-link-->
        <div class="dinline-block">
          <div class="sst fs24 mr5 dinline-block prelative">
            <span class="img-friend img-bg dinline-block vcenter"></span>友情链接
          </div>
          <span class="farial tc9 tupper">link</span>
        </div>
      </div>
      <div class="cont ofhidden pt15">
        <template v-for="(info,index) in infos.links">
          <template v-if="infos.links"  >
            <a  :key="index" target="_blank" :href="info.link" class="fd dinline-block vtop ofhidden mb15 tran3">
              <img :src="info['picture'][0]" alt="" width="155">
            </a>
          </template>
        </template>
        <!--nev-item v-if="infos.collegeScenery" :list="infos.collegeScenery"></nev-item-->
      </div>
    </div>
    <div class="ht25"></div>

  </div>
</template>

<script>
import Banner from '@/components/index/Banner'
import News from '@/components/index/News'
import NevItem from "@/components/index/NevItem";
import DiscItem from "@/components/index/DiscItem";
import Custome from "../../components/Custome";
export default {
  name: "index",
  components: {
    Banner,
    News,
    NevItem,
    DiscItem,
    Custome,
  },
  data(){
    return {
      infos:{},
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    $('.sns .tab').mouseover(function() {
      var key = $(this).data('key')
      $(this).addClass('sst').siblings('.tab').removeClass('sst')
      $('.sns .scont' + key).show().siblings('.scont').hide()
    })
  },
  methods:{
    getData(){
      this.$request.get('home',[],response => {
        if(response.data.code == 200){
          this.img=[]
          this.infos = response.data.data
        }
      },error => {
        console.log(error)
      })
    },
  }
  // beforeRouteEnter(to, form, next) {
  //   this.$refs.banner.initBanner();
  //   next()
  // },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue